import { put, del, get } from 'services/api-client';

const clientNotificationService = {
  save: (data) => put(`/client-notification`, data),

  delete: (id) => del(`/client-notification/${id}`),

  getForForm: (id) => get(`/client-notification/${id}/form`)
}

export default clientNotificationService;
